import {useEffect, useContext} from 'react';
import {DeviceContext} from '../context/DeviceContext';
import {DeviceStatus} from '../model/types';
import {AppConstants} from '../model/enums';

// const useSSE = (sessionId: string | null) => {
const useSSE = (sessionId: string | null) => {

  const deviceContext = useContext(DeviceContext);

  if (!deviceContext) {
    throw new Error('useSSE must be used within a DeviceProvider');
  }

  const {setDevices} = deviceContext; // DeviceProvider'dan gelen setDevices

  useEffect(() => {
    if (!sessionId) return; // SessionId ve loaded varsa dinlemeyi başlat

    const eventSource = new EventSource(`${AppConstants.url}/listen/?mySession=${sessionId}`);

    eventSource.addEventListener('message', (event) => {
      // Tek bir device'ın statusunu güncelliyoruz
      const deviceStatus = JSON.parse(event.data) as DeviceStatus;

      setDevices(prevDevices =>
        prevDevices.map(device =>
          device.id === deviceStatus.deviceId
            ? {
              ...device,

              pinCommand: deviceStatus.pinCommand,
              status: deviceStatus.status,
              loop: deviceStatus.loop,
              lp_count: deviceStatus.lp_count,
              loopRemainingCount: deviceStatus.loopRemainingCount,
              lp_off: deviceStatus.lp_off,
              lp_on: deviceStatus.lp_on,
              pin_on: deviceStatus.pin_on,

              person: deviceStatus.person,
              t1_user: deviceStatus.t1_user,
              toggleOFF: deviceStatus.toggleOFF,
              toggleON: deviceStatus.toggleON,
              relayState0: deviceStatus.relayState0,
              relayState1: deviceStatus.relayState1,
              scheduledActions: deviceStatus.scheduledActions || [],



            } // Gelen device'ın statusu güncellenir
            : device
        )
      );
    });

    return () => {
      eventSource.close();
    };
  }, [sessionId, setDevices]);
};

export default useSSE;
